import React, { useState } from "react";
import DetailedFacility from "../components/DetailedFacility";
import FacilityPreview from "../components/FacilityPreview";
import HfrRegisterUI from "./HfrRegisterFacility";

const Hfr = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    facilityInformation: {
      facilityName: "",
      facilityAddressDetails: {
        country: "",
        stateLGDCode: "",
        districtLGDCode: "",
        subDistrictLGDCode: "",
        facilityRegion: "",
        villageCityTownLGDCode: "",
        addressLine1: "",
        addressLine2: "",
        pincode: "",
        latitude: "",
        longitude: "",
      },
      facilityContactInformation: {
        facilityEmailId: "",
        facilityContactNumber: "",
        websiteLink: "",
        facilityLandlineNumber: "",
        facilityStdCode: "",
        appointmentLink: "",
      },
      ownershipCode: "",
      ownershipSubTypeCode: "",
      ownershipSubTypeCode2: "",
      typeOfServiceCode: "",
      specialityTypeCode: "SINGLE",
      systemOfMedicineCode: "",
      facilityTypeCode: "",
      facilitySubType: "",
      facilityOperationalStatus: "",
      facilityUploads: {
        facilityBuildingPhoto: { name: "", value: "" },
      },
      facilityAddressProof: [{ addressProofType: "", addressProofAttachment: { name: "", value: "" } }],
      timingsOfFacility: [],
      abdmCompliantSoftware: [{ existingSoftwares: [""], anyOther: "" }],
      aboutUs: "",
    },
  });

  return (
    <div>
      {step === 1 ? (
        <HfrRegisterUI setStep={setStep} formData={formData} setFormData={setFormData} />
      ) : step === 2 ? (
        <DetailedFacility setStep={setStep} formData={formData} setFormData={setFormData} />
      ) : (
        <FacilityPreview setStep={setStep} formData={formData} setFormData={setFormData} />
      )}
    </div>
  );
};

export default Hfr;